import request from '@/utils/request.js'
// import qs from 'qs';

/***套餐组变更记录***/
export function getChangepkgGroupList(data){
    return request({
        url: 'sim/change/pkgGroup/listPage',
        method: 'post',
        data
    })
}
export function exportSimInfo(data){
    return request({
        url: 'export/simAccountOrder',
        method: 'post',
        data
    })
}

export function exportSimInfoVip(data){
    return request({
        url: 'export/simAccountOrderVip',
        method: 'post',
        data
    })
}
export function exportSimInfo1(data){
    return request({
        url: 'export/simAccountOrderPrice',
        method: 'post',
        data
    })
}


/***SIM回收记录***/
export function getSimRecoveryList(data){
    return request({
        url: 'sim/recoverRecord/listPage',
        method: 'post',
        data
    })
}

/***SIM回收失败记录***/
export function getSimRecoveryFailList(data){
    return request({
        url: 'sim/recoverFail/listPage',
        method: 'post',
        data
    })
}

/***变更套餐过期时间列表***/
export function getChgPkgEndTimeList(data){
    return request({
        url: 'sim/pkg/endTimeList',
        method: 'post',
        data
    })
}


/***查询修改sim可用流量比记录***/
export function getFlowRatePercentList(data){
    return request({
        url: 'sim/select/flowRatePercent/listPage',
        method: 'post',
        data
    })
}

/**用户余额充值记录列表***/
export function getBalanceRechargeRecordList(data){
    return request({
        url: 'order/pc/user/investOrder',
        method: 'post',
        data
    })
}
export function getBalanceRechargeRecordListVip(data){
    return request({
        url: 'order/pc/user/investOrder/vip',
        method: 'post',
        data
    })
}


/**用户账户流水列表***/
export function getAccountFlowRecordList(data){
    return request({
        url: 'accountFlow/querySysUserAccountFlow',
        method: 'post',
        data
    })
}


/**查询用户账户余额***/
export function getUserBalance(data){
    return request({
        url: 'sysUser/user/account',
        method: 'post',
        data
    })
}



/**用户重置密码***/
export function resetPwd(data){
    return request({
        url: 'sysUser/user/account/resetPwd',
        method: 'post',
        data
    })
}


/**修改用户余额***/
export function changeBalance(data){
    return request({
        url: 'sysUser/user/account/change',
        method: 'post',
        data
    })
}


/** 获取用户微信注册地址 ***/
export function getAddressList(data){
    return request({
        url: 'sim/select/sysWxUser/address',
        method: 'post',
        data
    })
}
